import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import CustomizerContext from "../_helper/Customizer";
import { resolveLayoutSlug } from "../Layout/Sidebar/Menu";

/** Redirects /credora/... paths without :layout to the active theme layout slug. */
export default function CredoraRedirect({ basePath }) {
  const { layoutURL } = useContext(CustomizerContext);
  const location = useLocation();
  const pub = process.env.PUBLIC_URL || "";
  const normalized = `${pub}${basePath.startsWith("/") ? basePath : `/${basePath}`}`.replace(/\/$/, "");
  const pathname = location.pathname.replace(/\/$/, "");

  // Only redirect exact menu paths (sidebar links without a layout slug).
  if (pathname !== normalized) {
    return null;
  }

  const layout = resolveLayoutSlug(pathname, layoutURL);
  return <Navigate to={`${normalized}/${layout}`} replace />;
}
